import { Component, inject, Input } from "@angular/core";
import { CourseTest } from "@app/core/domain/course-test";
import {
  IonButton,
  IonContent,
  IonHeader,
  IonIcon,
  IonTitle,
  IonToolbar,
  ModalController,
} from "@ionic/angular/standalone";
import { TranslatePipe } from "@ngx-translate/core";

// verwijder als oude toetsinschrijvingen verwijderd worden
@Component({
  selector: "pa-test-info-modal",
  templateUrl: "./test-info-modal.component.html",
  styleUrls: ["./test-info-modal.component.scss"],
  imports: [TranslatePipe, IonHeader, IonToolbar, IonButton, IonTitle, IonIcon, IonContent],
})
export class TestInfoModalComponent {
  @Input() courseCode!: string;
  @Input() courseName!: string;
  @Input() courseTests!: CourseTest[];
  private readonly modalCtrl = inject(ModalController);

  dismiss(): void {
    this.modalCtrl.dismiss().catch((err) => {
      console.error("Error dismissing Test info modal:", err);
    });
  }
}
